import BaseAPIClient from "../base/BaseAPIClient";
import moment from 'moment';

export default class AllowanceClient extends BaseAPIClient {
  whatIfBulkSetCheck(schoolId, zeroOutAllowancesMissingFromInput, allowances) {
    return this._post("v2/campus-administration/student-credit-allowance/what-if/bulk/", {
      schoolId,
      zeroOutAllowancesMissingFromInput,
      allowances,
    })
  }
  bulkSet(schoolId, zeroOutAllowancesMissingFromInput, allowances) {
    return this._post("v2/campus-administration/student-credit-allowance/bulk/", {
      schoolId,
      zeroOutAllowancesMissingFromInput,
      allowances,
    })
  }
}
